import { Button, Col, Image, Switch, message, Select } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import BasicFormComponent from "../../components/formComponent/BasicFormComponent";
import FormCheckbox from "../../components/general/FormCheckbox";
import FormSelect from "../../components/general/FormSelect";
import FormTextField from "../../components/general/FormTextField";
import {
  deleteRow,
  resetState,
  setFormFieldValue,
  setInitialState,
  setSearchFieldValue,
  submitForm,
} from "../../redux/actions/basicFormAction";
import {
  SET_SUPPORTING_TABLE,
  UPDATE_FORM_FIELD,
} from "../../redux/reduxConstants";
import DayTimePicker from "../../components/NewComponents/DayTimePicker";

const columns = [
  {
    title: "Category Name",
    dataIndex: "CategoryName",
    key: "CategoryName",
  },
  { title: "Department", dataIndex: "DepartmentName", key: "DepartmentName" },
  { title: "Sort Order", dataIndex: "SortOrder", key: "SortOrder" },
  {
    title: "Image",
    key: "image",
    render: (_, record) => (
      <Image
        src={process.env.REACT_APP_BASEURL + record.CategoryImage}
        style={{ width: "50px", height: "50px" }}
      />
    ),
  },
  {
    title: "Category Icon",
    key: "CategoryIcon",
    render: (_, record) => (
      <Image
        src={process.env.REACT_APP_BASEURL + record.CategoryIcon}
        style={{ width: "50px", height: "50px" }}
      />
    ),
  },
];

const Categories = () => {
  const dispatch = useDispatch();
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);
  const [updateId, setUpdateId] = useState(null);

  const [dayList, setDayList] = useState([]);
  const [showTimePicker, setShowTimePicker] = useState(false);

  const [categoryImage, setCategoryImage] = useState(null);
  const [removeCategoryImage, setRemoveCategoryImage] = useState(false);
  const [categoryIcon, setCategoryIcon] = useState(null);
  const [removeCategoryIcon, setRemoveCategoryIcon] = useState(false);

  console.log("checking categroy Image", categoryImage);
  console.log("checking categroy Icon", categoryIcon);

  const [lastCreatedProduct, setLastCreatedProduct] = useState(null);

  let selectedImgUrl = "";

  const {
    formFields,
    searchFields,
    itemList,
    formLoading,
    tableLoading,
    supportingTable,
  } = useSelector((state) => state.basicFormReducer);

  useEffect(() => {
    if (supportingTable) {
      const allTables = Object.values(supportingTable);
      const lastTable = allTables[allTables.length - 1];
      const created = lastTable?.find((item) => item.IsCreated);

      if (created) {
        setLastCreatedProduct(created);
      }
    }
  }, [supportingTable]);

  const initialFormValues = {
    OperationId: null,
    CompanyId: null,
    CategoryId: null,
    DepartmentId: null,
    CategoryName: "",
    UserId: null,
    UserIP: "",
    CategoryImage: "",
    CategoryIcon: "",
    IsEnable: true,
    SortOrder: "",
    CardStyle: "",
    lstCategoryDay: [
      // Optional: You can initialize with one empty day or leave it as an empty array
      {
        CategoryId: null,
        DayId: null,
        StartTime: "",
        EndTime: "",
      },
    ],
  };

  const [lstCategoryDay, setLstCategoryDay] = useState([]);

  let initialDepartmentId;

  if (supportingTable?.Table1 && Array.isArray(supportingTable?.Table1)) {
    initialDepartmentId = supportingTable?.Table1[0]?.DepartmentId;
  }

  // Function to get the latest sort order
  const getLatestSortOrder = () => {
    // Check both Table3 and Table2 for the latest value
    return (
      supportingTable?.Table3?.[0]?.LastSortOrder ??
      supportingTable?.Table2?.[0]?.LastSortOrder
    );
  };

  // Set initial sort order when component mounts
  useEffect(() => {
    if (supportingTable) {
      const lastSortOrder = getLatestSortOrder();

      dispatch({
        type: UPDATE_FORM_FIELD,
        payload: {
          ...initialFormValues,
          SortOrder: lastSortOrder,
        },
      });

      console.log("last sort order", lastSortOrder);
    }
  }, [itemList, supportingTable]);

  // Update sort order when opening form
  const openForm = () => {
    let lastSortOrder;
    if (supportingTable) {
      lastSortOrder = getLatestSortOrder();
    }

    dispatch({
      type: UPDATE_FORM_FIELD,
      payload: {
        ...initialFormValues,
        SortOrder: lastSortOrder,
      },
    });
  };

  // Reset form including SortOrder when closing
  const closeForm = () => {
    setLstCategoryDay([]);

    setRemoveCategoryIcon(false);
    setRemoveCategoryImage(false);

    setCategoryIcon(null);
    handleFormChange({
      name: "CategoryIcon",
      value: "",
    });

    setCategoryImage(null);
    handleFormChange({
      name: "CategoryImage",
      value: "",
    });

    const formData = new FormData();
    formData.append("OperationId", 1);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("UserId", userData.UserId);
    formData.append("UserIP", "12.1.1.12");

    Object.keys(initialFormValues).map((keyName, i) => {
      return formData.append(keyName, initialFormValues[keyName]);
    });

    dispatch(
      setInitialState(
        "/CrudCategory",
        formData,
        initialFormValues,
        initialSearchValues,
        controller,
        userData,
        true
      )
    );
  };

  const initialSearchValues = {
    CategoryId: null,
    DepartmentId: initialDepartmentId,
    CategoryName: "",
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append("OperationId", 1);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("UserId", userData.UserId);
    formData.append("UserIP", "12.1.1.12");

    Object.keys(initialFormValues).map((keyName, i) => {
      return formData.append(keyName, initialFormValues[keyName]);
    });

    dispatch(
      setInitialState(
        "/CrudCategory",
        formData,
        initialFormValues,
        initialSearchValues,
        controller,
        userData,
        true
      )
    );

    return () => {
      controller.abort();
      dispatch(resetState());
    };
  }, []);

  const handleCategoryImageChange = (e) => {
    const file = e.target.files[0];
    
     if (!file) return;

  // ✅ Check size (600 KB = 600 * 1024 bytes)
  if (file.size > 600 * 1024) {
    alert("File size must be ≤ 600 KB");
    return;
  }

    if (file) {
      setCategoryImage(file);
    }
  };

  const handleCategoryIconChange = (e) => {
    const file = e.target.files[0];
    console.log("checking file size", file)
    if (!file) return;

    const maxSizeInMB = 1;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      message.error(
        `❌ Image size must be less than ${maxSizeInMB} MB. And aspect ratio must be 1:1 (square).`
      );
      return;
    }

    setCategoryIcon(file);
  };

  useEffect(() => {
    if (updateId !== null) {
      dispatch({
        type: UPDATE_FORM_FIELD,
        payload: itemList.filter((item) => item.CategoryId === updateId)[0],
      });
    }
    setUpdateId(null);
  }, [updateId]);

  useEffect(() => {
    if (
      supportingTable?.Table4 &&
      supportingTable?.Table3 &&
      formFields?.CategoryId
    ) {
      const matchedCategoryDays = supportingTable.Table3.map((day) => {
        const matched = supportingTable.Table4.find(
          (item) =>
            item.CategoryId === formFields.CategoryId &&
            item.DayId === day.SetupDetailId
        );

        return {
          CategoryId: formFields.CategoryId,
          DayId: day.SetupDetailId,
          StartTime: matched ? matched.StartTime?.slice(0, 5) : "",
          EndTime: matched ? matched.EndTime?.slice(0, 5) : "",
          IsActive: !!matched,
        };
      });

      setLstCategoryDay(matchedCategoryDays);
    }
  }, [
    supportingTable?.Table4,
    supportingTable?.Table3,
    formFields?.CategoryId,
  ]);

  const handleSearchChange = (data) => {
    dispatch(setSearchFieldValue(data));
  };

  const handleFormChange = (data) => {
    dispatch(setFormFieldValue(data));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchFields.CategoryName = searchFields.CategoryName.trim();

    const formData = new FormData();
    formData.append("OperationId", 1);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("UserId", userData.UserId);
    formData.append("UserIP", "12.1.1.12");

    Object.keys(searchFields).map((keyName, i) =>
      formData.append(keyName, searchFields[keyName])
    );
    dispatch(
      setInitialState(
        "/CrudCategory",
        formData,
        initialFormValues,
        searchFields,
        controller,
        userData,
        true
      )
    );
  };

  const handleDeleteRow = (categoryId) => {
    const formData = new FormData();
    formData.append("OperationId", 4);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("UserId", userData.UserId);
    formData.append("UserIP", "12.1.1.12");
    formData.append("CategoryId", categoryId);
    dispatch(
      deleteRow(
        "/crudCategory",
        formData,
        controller,
        userData,
        (data) => {
          let tables = data;
          delete tables.Table;
          delete tables.Table1;

          const finalTables = { Table1: tables.Table2 };

          dispatch({
            type: SET_SUPPORTING_TABLE,
            payload: finalTables,
          });
        },
        true
      )
    );
  };

  const handleFormSubmit = (e, operationID) => {
    // todo
    e.preventDefault();

    const formData = new FormData();
    // Append only the properties that exist in your C# model

    formData.append("CompanyId", userData.CompanyId);
    formData.append("CategoryId", formFields.CategoryId || ""); // Empty string if null
    formData.append("DepartmentId", formFields.DepartmentId || ""); // Empty string if null
    formData.append("CategoryName", formFields.CategoryName || "");
    formData.append("UserId", userData.UserId);
    formData.append("UserIP", "12.1.1.12");

    // Append image if exists
    // if (categoryImage) {
    formData.append("CategoryImage", categoryImage);
    // } else if (removeCategoryImage) {
    //   formData.append("CategoryImage", "null");
    // }

    // if (categoryIcon) {
    formData.append("CategoryIcon", categoryIcon);
    // } else if (removeCategoryIcon) {
    //   formData.append("CategoryIcon", "null");
    // }

    formData.append("IsEnable", formFields.IsEnable ? "true" : "false");
    formData.append("SortOrder", formFields.SortOrder || "");
    formData.append("CardStyle", formFields.CardStyle || "");

    lstCategoryDay
      .filter((day) => day.IsActive && day.StartTime && day.EndTime)
      .forEach((day, index) => {
        formData.append(
          `lstCategoryDay[${index}].CategoryId`,
          formFields.CategoryId || ""
        );
        formData.append(`lstCategoryDay[${index}].DayId`, day.DayId);
        formData.append(`lstCategoryDay[${index}].StartTime`, day.StartTime);
        formData.append(`lstCategoryDay[${index}].EndTime`, day.EndTime);
      });

   let operationId;

if (operationID === 2) {
  // Creation mode → always stay as 2
  operationId = 2;
} else {
  // Update mode
  if (
    (categoryImage || removeCategoryImage) &&
    (categoryIcon || removeCategoryIcon)
  ) {
    operationId = 3; // Full Update
  } else if (categoryImage || removeCategoryImage) {
    operationId = 5; // Update except icon
  } else if (categoryIcon || removeCategoryIcon) {
    operationId = 6; // Update except image
  } else {
    operationId = operationID; // No changes
  }
}


    formData.append("OperationId", operationId);

    console.log("OperationId", operationId);

    dispatch(
      submitForm(
        "/crudCategory",
        formData,
        initialFormValues,
        controller,
        userData,
        operationId,
        handleResponse,
        true
      )
    );

    setCategoryIcon(null);
    setCategoryImage(null);

    setRemoveCategoryImage(false);
    setRemoveCategoryIcon(false);

    handleFormChange({
      name: "CategoryIcon",
      value: "",
    });
    handleFormChange({
      name: "CategoryImage",
      value: "",
    });

    closeForm();
  };

  const handleResponse = (data) => {
    const allTables = Object.values(data);
    const lastTable = allTables[allTables.length - 1];
    const created = lastTable?.find((item) => item.IsCreated);

    if (created) {
      setLastCreatedProduct(created);
    }
  };

  const searchPanel = (
    <Fragment>
      <FormSelect
        colSpan={4}
        listItem={supportingTable.Table1 || []}
        idName="DepartmentId"
        valueName="DepartmentName"
        size={INPUT_SIZE}
        name="DepartmentId"
        label="Department"
        value={searchFields.DepartmentId || ""}
        onChange={handleSearchChange}
        disabled={!supportingTable.Table1}
      />
      <FormTextField
        colSpan={4}
        label="Category Name"
        name="CategoryName"
        size={INPUT_SIZE}
        value={searchFields.CategoryName || ""}
        onChange={handleSearchChange}
      />
    </Fragment>
  );

  const formPanel = (
    <Fragment>
      <FormSelect
        colSpan={8}
        listItem={supportingTable.Table1 || []}
        idName="DepartmentId"
        valueName="DepartmentName"
        size={INPUT_SIZE}
        name="DepartmentId"
        label="Department"
        value={formFields.DepartmentId || ""}
        onChange={handleFormChange}
        disabled={!supportingTable.Table1}
        required={true}
      />

      <FormTextField
        colSpan={8}
        label="Category Name"
        name="CategoryName"
        size={INPUT_SIZE}
        value={formFields.CategoryName || ""}
        onChange={handleFormChange}
        required={true}
      />
      <FormTextField
        colSpan={8}
        label="Sort Order"
        name="SortOrder"
        size={INPUT_SIZE}
        value={formFields.SortOrder || ""}
        onChange={handleFormChange}
      />

      <div className="flex flex-col w-[33%] px-1">
        <p>Plz Select Cards Style</p>
        <Select
          className="w-full"
          placeholder="Select Card Style"
          value={formFields.CardStyle || ""} // current selected value
          onChange={(value) => {
            handleFormChange({
              name: "CardStyle", // fixed name
              value: value, // selected CardStyle from Table5
            });
          }}
          options={(supportingTable.Table5 || []).map((item) => ({
            label: item.SetupDetailName, // what user sees
            value: item.CardStyle, // actual value
          }))}
          disabled={!supportingTable.Table5}
        />
      </div>

      {/* <FormSelect
        colSpan={8}
        listItem={[]}
        idName="DepartmentId"
        valueName="DepartmentName"
        size={INPUT_SIZE}
        name="DepartmentId"
        label="Card Style"
        value={"Vertical"}
        onChange={handleFormChange}
        disabled={true}
        required={false}
      /> */}

      <div className="flex gap-3 items-end justify-between rounded-lg  px-4 ">
        <span c>Is Enable</span>
        <Switch
          checked={formFields.IsEnable}
          onChange={(checked) =>
            handleFormChange({ name: "IsEnable", value: checked })
          }
          className="bg-black"
        />
      </div>

      <div className="flex gap-3">
        {/* Category Image */}
        <Col span={12} className="flex flex-col gap-2 border p-4 rounded-lg">
          <div className="px-4">
            <span className="text-lg font-semibold">Category Image</span>
            <input
              type="file"
              accept="image/*"
              onChange={handleCategoryImageChange}
            />
            <span>
              Note: Image Resolution should be ≤ 1400x400 and Size ≤ 600 KB
            </span>
            <br />
            <img
              src={
                categoryImage
                  ? URL.createObjectURL(categoryImage)
                  : formFields.CategoryImage
                  ? process.env.REACT_APP_BASEURL + formFields.CategoryImage
                  : ""
              }
              alt=""
              style={{ width: "250px", height: "auto", objectFit: "cover" }}
            />

            <br />
            <Button
              className="w-[200px]"
              onClick={() => {
                setCategoryImage(null);
                setRemoveCategoryImage(true);
                handleFormChange({
                  name: "CategoryImage",
                  value: "",
                });
              }}
            >
              Remove Image
            </Button>
          </div>
        </Col>

        {/* Category Icon */}
        <Col span={12} className="flex flex-col gap-2 border p-4 rounded-lg">
          <div className="px-4">
            <span className="text-lg font-semibold">Category Icon</span>
            <input
              type="file"
              accept="image/*"
              onChange={handleCategoryIconChange}
            />
            <span>
              Note: Aspect ratio must be 1:1 (square) & Size : 250 * 250 px
            </span>
            <br />
            <img
              src={
                categoryIcon
                  ? URL.createObjectURL(categoryIcon)
                  : formFields.CategoryIcon
                  ? process.env.REACT_APP_BASEURL + formFields.CategoryIcon
                  : ""
              }
              alt=""
              style={{ width: "250px", height: "auto", objectFit: "cover" }}
            />
            <br />
            <Button
              className="w-[200px]"
              onClick={() => {
                setCategoryIcon(null);
                setRemoveCategoryIcon(true);
                handleFormChange({
                  name: "CategoryIcon",
                  value: "",
                });
              }}
            >
              Remove Icon
            </Button>
          </div>
        </Col>
      </div>

      {/* todo of timing work */}
      <div>
        <DayTimePicker
          daysData={supportingTable?.Table3}
          categoryId={formFields?.CategoryId}
          initialValues={lstCategoryDay}
          onChange={(updatedDays) => {
            setLstCategoryDay(updatedDays);
          }}
        />
      </div>
    </Fragment>
  );

  return (
    <BasicFormComponent
      formTitle="Product Categories"
      searchPanel={searchPanel}
      formPanel={formPanel}
      searchSubmit={handleSearchSubmit}
      onFormSave={handleFormSubmit}
      tableRows={itemList}
      tableLoading={tableLoading}
      formLoading={formLoading}
      tableColumn={columns}
      deleteRow={handleDeleteRow}
      actionID="CategoryId"
      editRow={setUpdateId}
      fields={initialFormValues}
      crudTitle="Product Category"
      onFormClose={closeForm}
      onFormOpen={openForm}
      lastCreatedProduct={lastCreatedProduct}
    />
  );
};

export default Categories;
